import { DownloadOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Alert, Button, Modal, Space, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { canShareFile, saveFile, shareFile } from '@/lib/share';

/**
 * Файл готов — отправить или скачать (телефон). Меню «Поделиться» открывается отдельным
 * нажатием: Safari разрешает его только прямо по нажатию, а после ожидания сервера
 * разрешение уже истекло.
 */
export function ShareFileModal({
  title,
  file,
  sendText,
  hint,
  onClose,
}: {
  title: string;
  file: File;
  /** Подпись главной кнопки, например «Отправить или напечатать». */
  sendText: string;
  /** Что есть в меню «Поделиться» для этого файла. */
  hint: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  const shareable = canShareFile(file);
  return (
    <Modal open title={title} onCancel={onClose} footer={null} destroyOnHidden>
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Alert type="success" showIcon message={t('share.ready', { name: file.name })} />
        {shareable && (
          <Button
            type="primary"
            size="large"
            block
            icon={<ShareAltOutlined />}
            onClick={() => {
              void shareFile(file).then((ok) => {
                setFailed(!ok);
              });
            }}
          >
            {sendText}
          </Button>
        )}
        <Button
          size="large"
          block
          icon={<DownloadOutlined />}
          onClick={() => {
            saveFile(file);
          }}
        >
          {t('share.download')}
        </Button>
        <Typography.Text type="secondary">
          {shareable ? hint : t('share.downloadHint')}
        </Typography.Text>
        {failed && <Alert type="error" showIcon message={t('share.failed')} />}
        <Button block onClick={onClose}>
          {t('share.done')}
        </Button>
      </Space>
    </Modal>
  );
}
